import React from "react";
import { Sparkles, ShoppingBag, Megaphone, Users, TrendingUp } from "lucide-react";
import { Card } from "../ui/card";
import { Badge } from "../ui/badge";

const ITEMS = [
  { icon: ShoppingBag, label: "Shopify revenue & AOV" },
  { icon: Users, label: "Returning vs new customers" },
  { icon: Megaphone, label: "Ad spend & blended ROAS" },
  { icon: TrendingUp, label: "Cohort retention trends" },
];

export default function Phase2ComingSoon() {
  return (
    <Card
      className="p-6 border-dashed bg-accent/30"
      data-testid="phase2-coming-soon"
    >
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary">
            <Sparkles className="h-5 w-5" />
          </div>
          <div>
            <div className="flex items-center gap-2">
              <h3 className="font-display text-lg font-semibold">Ecommerce & marketing</h3>
              <Badge variant="secondary" className="text-[10px]">Phase 2</Badge>
            </div>
            <p className="text-sm text-muted-foreground mt-1 max-w-xl">
              Shopify orders, CAC, ROAS, attribution and cohort views are queued for the next release.
              Architecture is ready — wiring will plug in without a rewrite.
            </p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-6">
        {ITEMS.map(({ icon: Icon, label }) => (
          <div
            key={label}
            className="rounded-lg border border-dashed border-border p-3 opacity-70"
            data-testid={`phase2-item-${label.replace(/\s+/g, "-").toLowerCase()}`}
          >
            <Icon className="h-4 w-4 text-muted-foreground" />
            <p className="text-xs font-medium mt-2">{label}</p>
            <p className="text-[10px] text-muted-foreground mt-0.5">Coming soon</p>
          </div>
        ))}
      </div>
    </Card>
  );
}
